import React,{useEffect} from 'react';
import s from './Modal.module.css';
export function Modal({title,children,footer,onClose,maxWidth=500}){
  useEffect(()=>{const h=e=>{if(e.key==='Escape')onClose()};document.addEventListener('keydown',h);return()=>document.removeEventListener('keydown',h)},[onClose]);
  return(
    <div className={s.ov} onClick={e=>e.target===e.currentTarget&&onClose()}>
      <div className={s.box} style={{maxWidth}}>
        <div className={s.hd}><h3 className={s.ti}>{title}</h3><button className={s.cl} onClick={onClose}>✕</button></div>
        <div className={s.bd}>{children}</div>
        {footer&&<div className={s.ft}>{footer}</div>}
      </div>
    </div>
  );
}
